import React from "react";
import { ArrowUpRight, Linkedin, Instagram, Twitter, Facebook } from "lucide-react";
import { profile, navLinks, services } from "../../mock/mock";

const iconFor = (label) => ({ LinkedIn: Linkedin, Instagram, Twitter, Facebook }[label] || Linkedin);

export default function Footer() {
  const year = new Date().getFullYear();
  return (
    <footer className="relative border-t border-white/5 pt-20 pb-8 overflow-hidden">
      <div className="halo -bottom-60 left-1/2 -translate-x-1/2 opacity-40" />

      <div className="relative mx-auto max-w-[1400px] px-6 md:px-10">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 pb-16">
          <div className="lg:col-span-7">
            <div className="section-label mb-6">Let's build</div>
            <h3 className="font-display text-[44px] md:text-[72px] lg:text-[96px] leading-[0.95] tracking-[-0.03em]">
              Have a brand worth <br />
              <span className="italic sage-text">growing?</span>
            </h3>
            <a href="#contact" className="mt-10 inline-flex btn-primary">
              Start a Project <ArrowUpRight size={18} />
            </a>
          </div>

          <div className="lg:col-span-5 grid grid-cols-2 gap-10">
            <div>
              <div className="mono text-[10px] tracking-[0.22em] uppercase text-[var(--muted)] mb-5">Navigate</div>
              <ul className="space-y-3">
                {navLinks.map((l) => (
                  <li key={l.href}>
                    <a href={l.href} className="text-[15px] text-[var(--text-dim)] hover:text-[var(--sage)] transition-colors">{l.label}</a>
                  </li>
                ))}
              </ul>
            </div>
            <div>
              <div className="mono text-[10px] tracking-[0.22em] uppercase text-[var(--muted)] mb-5">Services</div>
              <ul className="space-y-3">
                {services.slice(0, 6).map((s) => (
                  <li key={s.title}>
                    <a href="#services" className="text-[15px] text-[var(--text-dim)] hover:text-[var(--sage)] transition-colors">{s.title}</a>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>

        <div className="hairline w-full" />

        <div className="pt-8 flex flex-col md:flex-row md:items-center md:justify-between gap-6">
          <div className="flex items-center gap-3">
            <span className="inline-flex h-9 w-9 items-center justify-center rounded-full border border-white/15 bg-white/5">
              <span className="font-display text-[18px] leading-none">A</span>
            </span>
            <div className="leading-tight">
              <div className="font-display text-[16px]">Anand Baral</div>
              <div className="mono text-[10px] tracking-[0.18em] uppercase text-[var(--muted)]">Blending creativity with strategy</div>
            </div>
          </div>

          <div className="flex items-center gap-4">
            {profile.socials.map((s) => {
              const Icon = iconFor(s.label);
              return (
                <a key={s.label} href={s.url} target="_blank" rel="noreferrer" aria-label={s.label}
                  className="h-10 w-10 rounded-full border border-white/10 inline-flex items-center justify-center text-[var(--text-dim)] hover:text-[var(--sage)] hover:border-[var(--sage)]/50 transition-colors">
                  <Icon size={15} />
                </a>
              );
            })}
          </div>

          <div className="flex flex-col md:items-end gap-1">
            <a href={profile.agency.url} target="_blank" rel="noreferrer"
              className="mono text-[11px] tracking-[0.14em] uppercase text-[var(--text-dim)] hover:text-[var(--sage)] transition-colors">
              A venture of {profile.agency.name}
            </a>
            <span className="mono text-[11px] tracking-[0.14em] uppercase text-[var(--muted)]">
              &copy; {year} Anand Baral &mdash; All rights reserved
            </span>
          </div>
        </div>
      </div>
    </footer>
  );
}
